<template lang="pug">
//-  #theMapbox(v-if="$store.state.historyMap.data" ref="mapBoxContianer"  )
//-    div() {{trackTime}}
//-    mgl-map(ref="locationMap" :zoom="pZoom" :center.sync="center"  :style="{'width':'100%','height':`${height-heightOffset}px`}"  :accessToken="accessToken" :mapStyle="mapStyle" @load="onMapLoaded" )
//-      mgl-marker(:coordinates="[xPos, yPos]" color='green')
//-        .marker(slot="marker")
//-          //- v-card.popUp() {{($store.getters["historyMap/getProgress"]).toFixed(2)}},{{speed.toFixed(2)}}
//-          v-icon.arrow(  size="32" color="primary" :style="{'transform':`rotate(${rotate}deg)`}") navigation
</template>
<script>



export default {
  props: {
    height: null
  },

  components: {
  },

  watch: {
    histroyData: function(val) {
      console.log(val);
    }
  },

  data: () => ({
    pZoom: 17,
    center: { lng: 36.74372678308009, lat: -1.2878468314658136 },
    accessToken:
      "pk.eyJ1IjoibXVnYW1iaWtpbWF0aGkiLCJhIjoiY2p0OWNjaGZxMDdsdjQ0cXZjZTRhZnA0aSJ9.3b3qa7uHHInxWL3TBiMsSQ",
    mapStyle: "mapbox://styles/mapbox/streets-v10",
    xPos: 36.74372678308009,
    yPos: -1.2878468314658136,
    rotate: 0,
    speed: 0,
    trackTime: null,
    timeline: 0,
    heightOffset: 218
  }),

  mounted() {
    this.theProgress = this.$store.state.historyMap.progress;
    let obj = {};
    obj.vehicle_id = "e6227816-02a5-4297-bca4-78e8d61e991b";
    obj.fromUTC = new Date("8 February 2020 9:50 GMT+300").toUTCString();
    obj.toUTC = new Date("8 February 2020 15:00 GMT+300").toUTCString();
    // load the Timeline Data
    this.$store.dispatch("historyMap/loadHistoryMap", obj).then(() => {
      console.log(this.$store.state.historyMap.data);
      if (this.$store.state.historyMap.data) {
        this.xPos = this.$store.state.historyMap.data[0].location.lon;
        this.yPos = this.$store.state.historyMap.data[0].location.lat;
        this.watchProgress = this.$store.state.historyMap.progress;
        this.center = { lng: this.xPos, lat: this.yPos };
        // initialize the Timeline
        this.initTimeline();
        this.timeline.progress(this.$store.getters["historyMap/getProgress"]);
        this.$store.timeline = this.timeline;
        //init the map
        this.$nextTick(() => {
          // console.log(this.height);
        });
      }
    });
  },


  computed: {
    // trackTime: {
    //   get: function() {
    //     console.log(this.$store.state.historyMap.trackTime);
    //     return this.$store.state.historyMap.trackTime;
    //   },
    //   set: function(value) {
    //     console.log(`time is: ${value}`);
    //     this.$store.commit("historyMap/setTrackTime", value);
    //   }
    // }

    histroyData: function() {
      return this.$store.state.historyMap.data;
    }
  },

  methods: {
    onMapLoaded(event) {
      event.center = { lng: this.xPos, lat: this.yPos };
    },

    initTimeline: function() {
      // this.timeline = new TimelineLite({
      //   paused: true,
      //   onUpdate: this.updateTimeline
      // });
      //
      // let theTime; // the current time
      // let prevTime; // the next time
      // let timeDifference; // time differerence in seconds
      //
      // // set the intial place
      // if (this.$store.state.historyMap.data.length) {
      //   this.xPos = this.$store.state.historyMap.data[0].location.lon;
      //   this.yPos = this.$store.state.historyMap.data[0].location.lat;
      //   this.rotate = this.$store.state.historyMap.data[0].angle;
      //   this.trackTime = parseInt(
      //     new Date(this.$store.state.historyMap.data[0].time).getTime()
      //   );
      // }
      //
      // // Loop to insert points from store
      // for (var i = 0; i <= this.$store.state.historyMap.data.length - 1; i++) {
      //   // calculate time differences
      //   theTime = new Date(this.$store.state.historyMap.data[i].time);
      //   if (i == 0) {
      //     timeDifference = 0;
      //   } else {
      //     prevTime = new Date(this.$store.state.historyMap.data[i - 1].time);
      //     timeDifference = (theTime.getTime() - prevTime.getTime()) / 1000.0;
      //   }
      //
      //   // console.log(`difference ${timeDifference}`);
      //
      //   this.timeline.to(this.$data, timeDifference, {
      //     xPos: this.$store.state.historyMap.data[i].location.lon,
      //     yPos: this.$store.state.historyMap.data[i].location.lat,
      //     rotate: this.$store.state.historyMap.data[i].angle,
      //     speed: this.$store.state.historyMap.data[i].speed,
      //     trackTime: parseInt(
      //       new Date(this.$store.state.historyMap.data[i].time).getTime()
      //     ),
      //     ease: Linear.easeNone // no easing
      //   });
      // }
    },

    //update the timeline by moving the progress
    updateTimeline: function() {
      // console.log(`the update is: ${this.timeline.progress()}`);

      this.$store.commit("historyMap/setAnimationProperties", {
        progress: this.timeline.progress() * 100,
        rotate: this.rotate,
        speed: this.speed,
        trackTime: this.trackTime
      });
    }
  }
};
</script>
<style scoped lang="stylus">
#theMapbox {
  height: 100%;
  background-color: #CCCCCC;
  position: relative;
}

.marker {
}

.arrow {
  margin-top: -20px;
  margin-left: 5px;
}
</style>
